<template>
  <default-layout>
    <template>
      <v-container id="receipt-container">
        <v-row>
          <v-col cols="12">
            <div>
              <v-card>
                <v-card-text class="receipt-card" v-if="payment.data">
                  <v-container fluid>
                    <v-row class="v-row">
                      <v-col>
                        <img
                          src="https://cdn2.hubspot.net/hubfs/5181917/rehab_logo_md.png"
                          alt="rehab.com logo"
                          class="logo"
                        />
                      </v-col>
                      <v-col class="receipt-header">
                        <h1
                          v-if="
                            !payment.success &&
                              payment.paymentTerm === 'Receipt'
                          "
                        >
                          FAILED PAYMENT
                        </h1>
                        <h1 v-else>INVOICE</h1>
                      </v-col>
                    </v-row>

                    <v-row class="spacing">
                      <v-col>
                        <p>
                          Rehab.com, LLC<br />
                          4400 North Scottsdale Road, Unit 842<br />
                          Scottsdale, AZ 85251
                        </p>
                      </v-col>
                      <v-col class="text-right">
                        <p>
                          <strong>
                            <span v-if="payment.paymentTerm == 'Receipt'"
                              >Date:
                            </span>
                            <span v-else>Paid: </span>
                          </strong>

                          {{ payment.createdAt | formatDate }}
                          <span v-if="payment.paymentTerm !== 'Receipt'">
                            <br />
                            <strong>Payment terms: </strong>
                            {{ payment.paymentTerm }}
                          </span>
                        </p>
                      </v-col>
                    </v-row>
                  </v-container>

                  <v-container>
                    <v-row>
                      <v-col>
                        <div class="md-layout-layout spacing">
                          <div class="md-layout-item">
                            <strong>SOLD TO:</strong><br />
                            {{ payment.billingName }}<br />
                            {{ payment.billingAddressLine1 }}<br />
                            <span v-if="payment.billingAddressLine2"
                              >{{ payment.billingAddressLine2 }}<br
                            /></span>
                            {{ payment.billingCity }},
                            {{ payment.billingState }}
                            {{ payment.billingZip }}
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-container>

                  <v-container>
                    <v-row>
                      <v-col>
                        <div class="md-layout spacing">
                          <v-simple-table class="md-layout-item receipt-table">
                            <thead class="table-head">
                              <tr>
                                <th>Date</th>
                                <th>Description</th>
                                <th>Quantity</th>
                                <th>Unit Price</th>
                                <th>Amount</th>
                              </tr>
                            </thead>

                            <template>
                              <!-- SUBSCRIPTIONS -->
                              <tr
                                v-for="subscription in payment.data
                                  .subscriptions"
                                :key="subscription.id"
                              >
                                <td>{{ payment.createdAt | formatDate }}</td>
                                <td>
                                  Premium listing ({{
                                    subscription.facilityId
                                  }})
                                </td>
                                <td class="text-center">1</td>
                                <td class="text-right">
                                  {{ subscription.total | formatPrice }}
                                </td>
                                <td class="text-right">
                                  {{ subscription.total | formatPrice }}
                                </td>
                              </tr>

                              <!-- CALL CAMPAIGNS -->
                              <tr
                                v-for="calls in calls"
                                :key="calls.campaignId"
                              >
                                <td v-if="calls.periodStart">
                                  {{ calls.periodStart | formatDate }} -
                                  {{ calls.periodEnd | formatDate }}
                                </td>
                                <td v-else>{{ payment.data.dateRange }}</td>
                                <td>
                                  Premium Calls for facility
                                  {{ calls.facilityId }}
                                </td>
                                <td class="text-center">
                                  {{ calls.totalCalls }}
                                </td>
                                <td class="text-right">
                                  {{ calls.interactionCost | formatPrice }}
                                </td>
                                <td class="text-right">
                                  {{
                                    (calls.interactionCost * calls.totalCalls)
                                      | formatPrice
                                  }}
                                </td>
                              </tr>

                              <!-- CLICK CAMPAIGNS -->
                              <tr
                                v-for="clicks in computedClicks"
                                :key="clicks.campaignId"
                              >
                                <td v-if="clicks.periodStart">
                                  {{ clicks.periodStart | formatDate }} -
                                  {{ clicks.periodEnd | formatDate }}
                                </td>
                                <td v-else>{{ payment.data.dateRange }}</td>
                                <td>
                                  Premium Clicks for facility
                                  {{ clicks.facilityId }}
                                </td>
                                <td class="text-center">
                                  {{ clicks.totalClicks }}
                                </td>
                                <td class="text-right">
                                  {{ clicks.interactionCost | formatPrice }}
                                </td>
                                <td class="text-right">
                                  {{
                                    (clicks.interactionCost *
                                      clicks.totalClicks)
                                      | formatPrice
                                  }}
                                </td>
                              </tr>

                              <!-- PREVIOUS PAYMENTS -->
                              <template v-if="!payment.data.type">
                                <tr
                                  v-for="partialPayment in payment.data
                                    .partialPayments"
                                  :key="'payment-' + partialPayment.id"
                                >
                                  <td>
                                    {{
                                      partialPayment.createdAt
                                        | formatDate("MMM do YYYY")
                                    }}
                                  </td>
                                  <td>Credit</td>
                                  <td class="text-center">1</td>
                                  <td class="text-right">
                                    {{
                                      partialPayment.data | formatPrevPayment
                                    }}
                                  </td>
                                  <td class="text-right">
                                    {{
                                      partialPayment.data | formatPrevPayment
                                    }}
                                  </td>
                                </tr>
                              </template>

                              <!-- FREE ACCOUNT -->
                              <tr v-if="payment.data.free">
                                <td>{{ payment.data.date }}</td>
                                <td>Free upgrade</td>
                                <td class="text-center">1</td>
                                <td class="text-right">
                                  {{ (payment.amount * -1) | formatPrice }}
                                </td>
                                <td class="text-right">
                                  {{ (payment.amount * -1) | formatPrice }}
                                </td>
                              </tr>

                              <!-- TOTALS LINE -->
                              <tr>
                                <td class="invisible-cell"></td>
                                <td class="invisible-cell"></td>
                                <td class="invisible-cell"></td>
                                <td class="text-right">
                                  <strong>TOTAL</strong>
                                </td>
                                <td v-if="payment.data.free" class="text-right">
                                  {{ 0 | formatPrice }}
                                </td>
                                <td v-else class="text-right">
                                  {{ payment.amount | formatPrice }}
                                </td>
                              </tr>
                            </template>
                          </v-simple-table>
                        </div>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </default-layout>
</template>

<script>
import { getPayment } from "../../api/payment";
import { addMinutes, format, parseISO } from "date-fns";
import { jsPDF } from "jspdf";

export default {
  name: "PaymentReceipt",
  title: "Payment Receipt",
  data() {
    return {
      payment: {}
    };
  },
  computed: {
    calls() {
      if (this.payment && this.payment.data && this.payment.data.callData) {
        return this.payment.data.callData.filter(call => call.callSpend > 0);
      }
      return [];
    },
    computedClicks() {
      console.log("CLICK DATA", this.payment.data.clickData);
      if (this.payment && this.payment.data && this.payment.data.clickData) {
        return this.payment.data.clickData.filter(
          click => click.clickSpend > 0
        );
      }
      return [];
    }
  },
  filters: {
    formatDate(date, dateFormat = "MM/dd/yyyy") {
      if (!date) return;
      console.log("DATE", date);
      date = parseISO(date);
      return format(addMinutes(date, date.getTimezoneOffset()), dateFormat);
    },
    formatPrice(value) {
      const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2
      });
      return formatter.format(value);
    }
  },
  async mounted() {
    this.payment = await getPayment(this.$route.params.paymentId);
    if (this.$route.params.download == true) {
      await this.takeScreenshot();
    }
  },
  methods: {
    async takeScreenshot() {
      let jsPdf = new jsPDF("p", "pt", "letter", true);
      var htmlElement = document.getElementById("receipt-container");
      const opt = {
        callback: function(jsPdf) {
          jsPdf.save("rehab-invoice.pdf");
        },
        margin: [20, 20, 20, 20],
        autoPaging: "text",
        html2canvas: {
          allowTaint: true,
          dpi: 600,
          letterRendering: true,
          logging: false,
          scale: 0.5
        }
      };

      jsPdf.html(htmlElement, opt);
    }
  }
};
</script>

<style lang="scss" scoped>
#receipt-container {
  font-family: "Roboto", sans-serif;
}
.receipt-card {
  padding: 30px;
}
.logo {
  display: block;
  max-width: 250px;
}
.receipt-header {
  text-align: right;
  h1 {
    font-weight: normal;
  }
}
.text-right {
  text-align: right;
}
.text-center {
  text-align: center;
}
.spacing {
  margin-top: 50px;
}

.receipt-table {
  .md-table-head {
    text-align: center;
    text-transform: uppercase;
    background-color: #eeeeee;
    border: 1px solid;
    line-height: 10px;
  }

  .md-table-head-label {
    line-height: 29px;
  }

  .md-table-head-container {
    padding: 0 !important;
    height: auto !important;
  }

  tr {
    pointer-events: none;
  }
  .invisible-cell {
    border: none;
  }
}
</style>
